import React, { useState } from 'react';
import { Box, Menu, MenuItem, useTheme, alpha } from '@mui/material';
import { CalendarTodayOutlined as CalendarIcon, ExpandMore as CaretIcon, Check as CheckIcon } from '@mui/icons-material';
import { PERIOD_OPTIONS } from './dashboardUtils';

/** Compact period picker: one pill showing the current period, a menu to change it. */
const PeriodSwitch = ({ value, onChange }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [anchor, setAnchor] = useState(null);
  const current = PERIOD_OPTIONS.find((p) => p.value === value) || PERIOD_OPTIONS[0];
  return (
    <>
      <Box
        role="button" tabIndex={0} aria-haspopup="menu" aria-expanded={Boolean(anchor)}
        onClick={(e) => setAnchor(e.currentTarget)}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setAnchor(e.currentTarget); } }}
        sx={{
          display: 'inline-flex', alignItems: 'center', gap: 1.5, pl: 2.5, pr: 1.5, py: 1.25, borderRadius: 999,
          fontSize: '0.8125rem', fontWeight: 600, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap',
          color: 'text.primary', bgcolor: isDark ? 'rgba(255,255,255,0.08)' : alpha('#fff', 0.7),
          transition: 'background-color 0.15s',
          '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.12)' : '#fff' },
        }}
      >
        <CalendarIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
        {current.label}
        <CaretIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
      </Box>
      <Menu
        anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: 1, borderRadius: 3, minWidth: 180, boxShadow: '0 12px 32px rgba(16,24,40,0.12)' } } }}
      >
        {PERIOD_OPTIONS.map((p) => (
          <MenuItem
            key={p.value} selected={p.value === value}
            onClick={() => { setAnchor(null); if (p.value !== value) onChange(p.value); }}
            sx={{ fontSize: '0.875rem', fontWeight: p.value === value ? 700 : 500, gap: 2, py: 1.5 }}
          >
            <Box component="span" sx={{ flex: 1 }}>{p.label}</Box>
            {p.value === value && <CheckIcon sx={{ fontSize: 16 }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default PeriodSwitch;
